import { render, staticRenderFns } from "./ecard.vue?vue&type=template&id=63db6da2"
import script from "./ecard.vue?vue&type=script&lang=js"
export * from "./ecard.vue?vue&type=script&lang=js"
import style0 from "./ecard.vue?vue&type=style&index=0&id=63db6da2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports